export const METRICS_RESET_STATE = 'METRICS_RESET_STATE';
export const METRICS_SET_DATA = 'METRICS_SET_DATA';



/** WEBPACK FOOTER **
 ** ./src/store/modules/report/metrics/types.js
 **/